const state = () => ({
    allListIndex: '',
    FloorIndex: '',
    LevelIndex: '',
    roomIndex: '',
    paymentPlatform: 0,

})
const getters = {
    allListIndex: (state) => state.allListIndex,
    FloorIndex: (state) => state.FloorIndex,
    LevelIndex: (state) => state.LevelIndex,
    roomIndex: (state) => state.roomIndex,
    // paymentPlatform: (state) => state.paymentPlatform,
}
const mutations = {

    setAllListIndex(state, allListIndex) {
        state.allListIndex = allListIndex
    },
    setFloorIndex(state, FloorIndex) {
        state.FloorIndex = FloorIndex
    },
    setLevelIndex(state, LevelIndex) {
        state.LevelIndex = LevelIndex
    },
    setRoomIndex(state, roomIndex) {
        state.roomIndex = roomIndex
    },
    setPaymentPlatform(state, paymentPlatform) {
        state.paymentPlatform = paymentPlatform
    }
}
const actions = {
    setAllListIndex({ commit }, allListIndex) {
        commit('setAllListIndex', allListIndex)
    },
    setFloorIndex({ commit }, FloorIndex) {
        commit('setFloorIndex', FloorIndex)
    },
    setLevelIndex({ commit }, LevelIndex) {
        commit('setLevelIndex', LevelIndex)
    },
    setRoomIndex({ commit }, roomIndex) {
        commit('setRoomIndex', roomIndex)
    },
    setPaymentPlatform({ commit }, paymentPlatform) {
        commit('setPaymentPlatform', paymentPlatform)
    }

}
export default {
    state,
    getters,
    mutations,
    actions,
}


// WEBPACK FOOTER //
// ./src/store/modules/checkRoom.js